// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".evaluation-list[data-v-11035ad7]{width:100%;overflow:scroll;height:33rem}", ""]);
// Exports
module.exports = exports;
